import graphql from './graphql';

const query = /* GraphQL */ `
  query User_listUsersByCourse(
    $courseId: ID!
    $fullName: String
    $department: String
    $jobTitle: String
    $terminal: String
    $lessonId: ID
  ) {
    User_listUsersByCourse(
      courseId: $courseId
      fullName: $fullName
      department: $department
      jobTitle: $jobTitle
      terminal: $terminal
      lessonId: $lessonId
    ) {
      wasUserEnrolled
      progress
      User {
        id
        fullName
        Department {
          name
        }
        Terminal {
          name
        }
        JobTitle {
          name
        }
        UserEvaluations {
          id
          grade
          isDraft
          scorerId
          totalLessonsCompletedManual
          totalLessonsCompletedAutomatic
          createdAt
        }
        UserLessons {
          id
          attended
          scorerId
          isDraft
          userId
          lessonId
        }
      }
    }
  }
`;

const UserListUsersByCourse = async ({
  courseId = null,
  fullName = null,
  department = null,
  jobTitle = null,
  terminal = null,
  lessonId = null,
}) =>
  graphql(query, {
    courseId,
    fullName,
    department,
    jobTitle,
    terminal,
    lessonId,
  }).then(
    // eslint-disable-next-line camelcase
    ({ User_listUsersByCourse }) => User_listUsersByCourse
  );

export default UserListUsersByCourse;
